export const account = {

    // --- حسابي (شاشة الإعدادات الجديدة: menu.vue + AccountWelcome.vue) ---
    mc_title: `حسابي`,
    mc_subtitle: `إعدادات حسابك وأعمالك`,
    mc_group_account: `الحساب`,
    mc_home: `الرئيسية`,
    mc_mydata: `بياناتي`,
    mc_subscription: `الاشتراك`,
    mc_billing: `الفوترة الإلكترونية`,
    mc_whatsapp: `واتساب للأعمال`,
    mc_notifications: `الإشعارات`,
    mc_team: `إدارة الفريق`,
    mc_team_badge: `جديد`,
    mc_integrations: `التكاملات`,
    mc_hello: `مرحبًا`,
    mc_welcome_sub: `مرحبًا بك في حسابك. من هنا تدير بيانات أعمالك والإعدادات التي يستخدمها النظام ليعمل نيابةً عنك.`,
    mc_quick: `وصول سريع`,
    mc_card_account_title: `إعدادات الحساب`,
    mc_card_account_desc: `بيانات التواصل ولغة اللوحة والأمان.`,
    mc_card_subscription_desc: `خطتك وفوترة الاشتراك.`,
    mc_card_billing_desc: `الجهات المُصدِرة للفواتير وأي جهة تُصدر فاتورة كل وحدة.`,
    mc_card_whatsapp_desc: `الاتصال الذي يتحدث النظام من خلاله مع ضيوفك.`,
    mc_card_notifications_desc: `أي تنبيهات تصلك وعبر أي قنوات.`,
    mc_card_team_desc: `ادعُ المتعاونين وأدر صلاحياتهم.`,
    mc_card_integrations_desc: `الاتصالات مع الخدمات الخارجية.`,

  p1: `أدِر حسابك`,
  p2: `إعدادات الحساب`,
  p3: `اللغة`,
  p4: `تسجيل الدخول والأمان`,
  p5: `اشتراكي`,
  p6: `بيانات الفوترة`,
  p7: `WhatsApp Business`,
  p8: `التكاملات`,
  p9: `إعدادات الحساب`,
  p10: `أدِر بيانات التواصل التي ستصلك عليها جميع رسائل WACheckin.`,
  p11: `تم تحديث البيانات بنجاح`,
  p12: `لغة المنصة`,
  p13: `اختر لغتك المفضّلة للوحة التحكم. لا يؤثر هذا الإعداد على لغة تسجيل الوصول التي يتلقّاها نزلاؤك، لأنها تعتمد على إعدادات أجهزتهم.`,
  p14: `اختر اللغة من القائمة`,
  p15: `اختر اللغة`,
  p16: `الإسبانية`,
  p17: `الإنجليزية`,
  p18: `تحديث اللغة`,
  p19: `تم تطبيق اللغة بنجاح`,
  p20: `من هنا يمكنك تحديث كلمة المرور للحفاظ على أمان حسابك.`,
  p21: `هل تريد تغيير كلمة المرور؟`,
  p22: `تغيير كلمة المرور`,
  p23: `تحقّق من بريدك الإلكتروني`,
  p24: `لمتابعة تغيير كلمة المرور، راجع بريدك الوارد واتبع الخطوات`,
  p25: `متابعة`,
  p26: `عفوًا! حدث خطأ غير متوقع`,
  p27: `تم تحديث البيانات بنجاح`,
  p28: `WhatsApp for Business`,
  p29: `اربط حساب WhatsApp Business بمنصّتنا وأرسل الرسائل إلى نزلائك مباشرةً من رقمك المخصّص.`,
  p30: `لا يوجد حساب مرتبط.`,
  p31: `ربط الحساب`,
  p32: `الحساب`,
  p33: `مرتبط`,
  p34: `فصل الحساب`,
  p35: `جارٍ تحميل المعلومات...`,
  p36: `فصل WhatsApp for Business`,
  p37: `هل تفكّر في فصل WhatsApp for Business والتوقّف عن إرسال الرسائل إلى نزلائك عبر WhatsApp؟`,
  p38: `فصل`,
  p39: `تم فصل حساب WhatsApp Business بنجاح`,
  p40: `تعذّر فصل حساب WhatsApp Business، يرجى التواصل مع الدعم`,
  p41: `رقم الهاتف`,
  p42: `حساب Facebook`,
  p43: `بيانات النشاط التجاري`,
  p44: `يجب أن يكون لديك رقم هاتف صالح وفريد لاستخدامه مع WhatsApp Business API.`,
  p45: `ستتلقّى رمز تحقّق لتوثيق رقمك على منصّتنا.`,
  p46: `يجب أن يكون رقم هاتف نشاطك التجاري رقمًا صالحًا يستوفي شروط`,
  p47: `منصّة WhatsApp for Business.`,
  p48: `ستتلقّى رمز تحقّق لتوثيق رقمك على منصّتنا.`,
  p49: `العودة إلى حالة الحساب`,
  p50: `متابعة`,
  p51: `يجب أن يكون لديك حساب Facebook شخصي (مرتبط ببريد عملك الإلكتروني)`,
  p52: `إذا أنشأت حساب Facebook Business وربطته بهذا النظام، فعليك توثيقه قبل بدء عملية الإعداد بالضغط على تسجيل الدخول باستخدام Facebook.`,
  p53: `لتوثيق حساب عملك، افتح`,
  p54: `هذا الرابط`,
  p55: `في تبويب منفصل.`,
  p56: `عليك إنشاء رمز في تطبيق المصادقة وإدخاله في حقل "أدخل الرمز".`,
  p57: `بعد التأكيد، يمكنك إغلاق هذا التبويب.`,
  p58: `العودة إلى حالة الحساب`,
  p59: `رجوع`,
  p60: `متابعة`,
  p61: `جهّز بيانات نشاطك التجاري`,
  p62: `يجب أن تكون معلومات نشاطك التجاري جاهزة: الاسم القانوني لشركتك وعنوانها، إضافةً إلى حساب العمل بالشكل الذي تريد عرضه به.`,
  p63: `يجب أن يكون لديك موقع إلكتروني صالح لنشاطك التجاري.`,
  p64: `عليك توثيق حسابك لدى Meta في أقرب وقت ممكن. يمكن للنشاط التجاري الموثّق أن يبدأ بإرسال 1000 رسالة يوميًا. وإذا لم توثّق حسابك، فستعطّله Meta.`,
  p65: `وفقًا لسياسة Meta، لا يمكن ربط حساب تجاري غير موثّق بأكثر من رقمين. وثّق الحساب لربطه بأرقام أكثر.`,
  p66: `العودة إلى حالة الحساب`,
  p67: `رجوع`,
  p68: `متابعة`,
  p69: `تم ربط حساب WhatsApp Business بنجاح`,
  
  p70: `الفوترة`,
  p71: `الحالة`,
  p72: `المبلغ المحصَّل`,
  p73: `مدفوعة`,
  p74: `معلّقة`,
  p75: `عرض الفاتورة`,
  p76: `لا توجد سجلات فوترة`,
  p77:`التاريخ`,
  p78: ``,
  p79: ``,
  p80: ``,
};
